import { ValidCaseState } from '@core/model/domain/caseState';
import { Mapper } from '@core/model/framework/mapper';
import { CaseClerkStateDto } from '@core/service/digital-factory/account/types/caseClerkDto';
import { injectable } from 'inversify';

@injectable()
export class CaseStateMapper implements Mapper<ValidCaseState, CaseClerkStateDto> {
  toDomain(status: CaseClerkStateDto): ValidCaseState {
    switch (status) {
      case 'WAITING_FOR_EXPLOITABLE_ANALYSIS':
        return 'RETRY_ACCOUNT';
      case 'ANALYSIS_IN_PROGRESS':
        return 'IN_PROGRESS';
      case 'SUCCEEDED':
        return 'SUCCESS';
      case 'TOO_MANY_ATTEMPTS':
      case 'ABORTED':
      case 'FAILED':
      default:
        return 'FAILED';
    }
  }
}
